export default class StoreLocatorFooterBlock {
    constructor(node) {
        this.node = node;
        this.autocomplete = new google.maps.places.Autocomplete(this.node.querySelector('#trova-negozio'), {});

        this.addListeners();
    }
    
    redirectToStoreLocator(searchString, searchPosition, geometryViewport, addressComponents) {
        let redirectUrl = "";

        redirectUrl = this.node.getAttribute('data-store-locator-url');
        redirectUrl += "?search=" + searchString;
        
        if (searchPosition !== undefined) {
            redirectUrl += "&searchPosition=" + searchPosition.toUrlValue();
        }
        
        if (geometryViewport !== undefined) {
            redirectUrl += "&viewport=" + geometryViewport.toUrlValue();
        }

        if (addressComponents !== undefined) {
            for (let i in addressComponents) {
                let addressComponent = addressComponents[i];

                for (let t in addressComponent.types) {
                    let addressComponentType = addressComponent.types[t];

                    if (addressComponentType === "administrative_area_level_1") {
                        redirectUrl += "&administrativeArea=" + addressComponent.short_name;
                    }
                    else if (addressComponentType === "country") {
                        redirectUrl += "&country=" + addressComponent.short_name;
                    }
                }
            }
        }
        
        window.location.href = redirectUrl;
    }
    
    addListeners() {
        let _this = this;
        
        this.autocomplete.addListener('place_changed', function() {
            let autocompletePlace = _this.autocomplete.getPlace();
            
            let searchString = _this.node.querySelector('#trova-negozio').value;

            if (autocompletePlace && autocompletePlace.geometry) {
                // Ho selezionato un opzione autcomplete.
                _this.redirectToStoreLocator(searchString, autocompletePlace.geometry.location, autocompletePlace.geometry.viewport, autocompletePlace.address_components);
            }
            else {
                // Ho premuto invio ma non ho selezionato alcuna opzione autocomplete.
                _this.redirectToStoreLocator(searchString);
            }
        });
        
        this.node.querySelector('input.goto-store-locator').addEventListener('click', function() {
            _this.redirectToStoreLocator(_this.node.querySelector('#trova-negozio').value);
        });
        
        this.node.addEventListener('submit', function(event) {
           event.preventDefault();
           
            _this.redirectToStoreLocator(_this.node.querySelector('#trova-negozio').value);
        });
    }

    static init() {
        let storeLocatorFooterBlockNode = document.querySelector("[data-store-locator-footer-block]");

        if (storeLocatorFooterBlockNode) {
            return new StoreLocatorFooterBlock(storeLocatorFooterBlockNode);
        }
    }
}